<template>
  <nav aria-label="breacrumb">
    <ol class="breadcrumb">
      <crumb
        v-for="crumb in crumbs"
        :key="crumb.index"
        :index="crumb.index"
        :icon="crumb.icon"
        :label="crumb.label"
        :collapsed="crumb.collapsed"
        @crumb-click="crumbClicked"
      >
      </crumb>
    </ol>
  </nav>
</template>
<script>
import Crumb from "./Crumb.vue";

const crumbClicked = function(index) {
  this.$emit("crumb-click", index);
};

export default {
  components: { Crumb },
  props: {
    trail: {
      type: Array,
      required: true,
    },
    rootLabel: {
      type: String,
      required: false,
      default: "",
    },
    rootIcon: {
      type: String,
      required: false,
      default: "fa-home",
    },
  },
  computed: {
    allCrumbs: function() {
      let crumbs = [];
      if (this.trail.length > 0) {
        crumbs = this.trail.map((label, index) => ({
          index,
          label,
        }));
      }

      let root;
      if (this.rootLabel) {
        root = { index: -1, label: this.rootLabel };
      } else {
        root = { index: -1, icon: this.rootIcon };
      }

      return [root, ...crumbs];
    },
    crumbs: function() {
      const crumbs = [...this.allCrumbs];
      if (crumbs.length > 2) {
        for (let i = 1; i < crumbs.length - 1; i++) {
          crumbs[i].collapsed = true;
        }
      }

      return crumbs;
    },
  },
  methods: {
    crumbClicked,
  },
  emits: ["crumb-click"],
};
</script>
<style lang="scss" scoped>
ol.breadcrumb {
  padding: 0;
  list-style: none;
}
</style>
